import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { TransactionDetails } from "./transactionDetails"
import { ITransactionDetails } from "./transactionDetails.types"
import { GetAccountCreditQuery } from "@/api/hasura/generated/graphql"

// An account_credit row, read by its be-financials primary key. Until SO-31069
// the id in hand was a Junifer one, so this had to come back wrapped in an
// entity_mappings row's account_credit_mapping.
export type ITransactionDetailsRaw =
  GetAccountCreditQuery["account_credit"][number]

export const TransactionDetailsParser: IParser<
  ITransactionDetails,
  ITransactionDetailsRaw
> = {
  toDomain: (data: ITransactionDetailsRaw) => {
    try {
      return new TransactionDetails(
        Number(data.id),
        data.reference ?? "",
        data.created_user ?? undefined,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
